import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "react-toastify";
import "./ShareThreadButton.css";

const ShareThreadButton = ({
  communityId,
  threadId,
  threadTitle,
  compact = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async (e) => {
    e.stopPropagation();

    const threadUrl = `${window.location.origin}/communities/${communityId}/threads/${threadId}`;

    try {
      // Try using the Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(threadUrl);
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = threadUrl;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      setCopied(true);
      toast.success("Link copied to clipboard!");

      // Reset icon after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
toast.error("Failed to copy link");
    }
  };

  if (compact) {
    return (
      <button
        className="share-thread-btn-compact"
        onClick={handleShare}
        title="Share discussion"
      >
        {copied ? <Check size={14} /> : <Share2 size={14} />}
      </button>
    );
  }

  return (
    <button
      className={`share-thread-btn ${copied ? "copied" : ""}`}
      onClick={handleShare}
      title="Share discussion"
    >
      {copied ? (
        <>
          <Check size={16} />
          <span>Copied!</span>
        </>
      ) : (
        <>
          <Share2 size={16} />
          <span>Share</span>
        </>
      )}
    </button>
  );
};

export default ShareThreadButton;
